import React from 'react';
import { ChevronRightRounded, PersonAddAlt1 } from '@mui/icons-material';
import { Colors } from 'library';
import { Card, Grid, Icon, Link, Row, Stack, Text, Title } from 'library/ui';
import { PermissionType, useUserContext } from 'UserContext';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';
import HowItWorksCard from './HowItWorksCard';
import StepTwoImage from 'assets/images/HowItWorksStepTwo.png';
import StepThreeImage from 'assets/images/HowItWorksStepThree.png';

const FAQ_URL = 'https://chatwoot.join-tandem.com/hc/child-care-center-help-center/en';
const SCHEDULE_CALL_URL = 'https://meetings.hubspot.com/sales-team/learn-more-about-tandem';

export default function HowItWorks() {
    const { goToPostJob } = usePostJobNavigation();
    const { hasPermission } = useUserContext();
    const canPostJobs = hasPermission(PermissionType.PostJob);

    function onPostJobClick() {
        if (!canPostJobs) {
            return;
        }

        goToPostJob('How It Works');
    }

    return (
        <Card>
            <Stack gap="md">
                <Stack gap="none" align="center">
                    <Title size="h2">The Tandem Process</Title>
                    <Text size="xs" tone="secondary">
                        Read our <Link href={FAQ_URL}>FAQ</Link> to learn more.
                    </Text>
                </Stack>
                <Grid columns={3} collapseAt="md" collapsedColumns={1} gap="md">
                    <HowItWorksCard>
                        <Text weight="bold" tone="accent">
                            STEP ONE
                        </Text>
                        <Text weight="bold">Post a Job</Text>
                        <Text size="xs" tone="secondary">
                            Tell us what you need and we&apos;ll begin recruiting.
                        </Text>
                        <Card onClick={() => onPostJobClick()} padding="sm" disabled={!canPostJobs}>
                            <Row justify="between" gap="sm">
                                <Row gap="sm">
                                    <Icon
                                        icon={PersonAddAlt1}
                                        size="sm"
                                        bgColor={Colors.primary}
                                        iconColor={Colors.white}
                                    />
                                    <Stack gap="none">
                                        <Text weight="bold">I need a substitute teacher...</Text>
                                        <Text size="xs" tone="secondary">
                                            A teacher called off, is on vacation, maternity leave, etc.
                                        </Text>
                                    </Stack>
                                </Row>
                                <ChevronRightRounded />
                            </Row>
                        </Card>
                        <Card onClick={() => window.open(SCHEDULE_CALL_URL, '_blank', 'noreferrer')} padding="sm">
                            <Row justify="between" gap="sm">
                                <Stack gap="none">
                                    <Text size="xs" weight="bold">
                                        Have questions around posting a job?
                                    </Text>
                                    <Text size="xs" tone="secondary">
                                        Schedule a call with Tandem
                                    </Text>
                                </Stack>
                                <ChevronRightRounded />
                            </Row>
                        </Card>
                    </HowItWorksCard>
                    <HowItWorksCard>
                        <Text weight="bold" tone="accent">
                            STEP TWO
                        </Text>
                        <Text weight="bold">Wait While We Work</Text>
                        <Text size="xs" tone="secondary">
                            We&apos;ll begin recruiting for your role. We&apos;ll place a teacher that fits all the
                            qualifications you&apos;re looking for.
                        </Text>
                        <img
                            src={StepTwoImage}
                            alt="Image showing a worker that is matched up to the requirements in the job posting"
                            style={{ maxWidth: 400 }}
                        />
                    </HowItWorksCard>
                    <HowItWorksCard>
                        <Text weight="bold" tone="accent">
                            STEP THREE
                        </Text>
                        <Text weight="bold">Meet Your Match</Text>
                        <Text size="xs" tone="secondary">
                            Once matched, you will receive their info and documents, and they will begin their
                            assignment. If they&apos;re a great fit, you can request them for future openings.
                        </Text>
                        <img
                            src={StepThreeImage}
                            alt="View workers information and downlaod their relevant documents"
                            style={{ maxWidth: 400 }}
                        />
                    </HowItWorksCard>
                </Grid>
            </Stack>
        </Card>
    );
}
